import { j as s } from "./jsx-runtime-3tyXYecC.mjs";
import { B as m, F as c } from "./enums-uX3E-11l.mjs";
import { a as l } from "./index-isgVnOkQ.mjs";
import { c as d, a as f, b as F } from "./hook-CrqgbaQ-.mjs";
import { useForm as u } from "react-hook-form";
import { L as y } from "./loader-CJQkrVUR.mjs";
async function p(o) {
  const { data: t } = await l.ajax.get(o);
  return t;
}
const g = {
  layout: { root: { id: "root" } },
  loading: !0,
  models: { root: { id: "root", type: m.Group } }
}, x = () => async ({ setState: o }, { endpoint: t }) => {
  try {
    const r = typeof t == "string" ? await p(t) : await t();
    o({
      layout: r.layout,
      loading: !1,
      models: r.models
    });
  } catch {
    console.error("Failed");
  }
}, j = (o) => ({ getState: t, setState: r }) => {
  const { models: a } = t(), e = a[o.id], i = {
    ...a,
    [o.id]: { ...e, ...o }
  };
  r({
    models: i,
    loading: !1
  });
}, C = {
  updateModel: j
}, n = F({
  initialState: g,
  actions: C
}), w = d(n, {
  onInit: x
}), S = f(n), B = () => {
  const [{ layout: o, loading: t, models: r }] = S(), a = u();
  return t ? /* @__PURE__ */ s.jsx(y, {}) : /* @__PURE__ */ s.jsx(c, { control: a.control, layout: o, models: r });
}, H = ({ formEndpoint: o }) => /* @__PURE__ */ s.jsx(w, { endpoint: o, children: /* @__PURE__ */ s.jsx(B, {}) });
export {
  H as F
};
//# sourceMappingURL=form-factory-0-config-CBXklBE3.mjs.map
